// extracted by mini-css-extract-plugin
export var headerCell = "_50-1";
export var loadingSpinnerContainer = "_50-4";
export var rowWrapper = "_50-3";
export var standaloneTable = "_50-5";
export var table = "_50-0";
export var white = "_50-2";